import ServiceTemplate from './ServiceTemplate';

const Vasectomy = () => {
  const data = {
    title: 'Vasectomy',
    tagline: 'Safe. Effective. Permanent Birth Control.',
    description: 'A vasectomy is a minimally invasive procedure for permanent contraception. It is one of the most effective forms of birth control available, with over 99% effectiveness.',
    causesTitle: 'Benefits of Vasectomy',
    causes: [
      'Over 99% effective at preventing pregnancy',
      'Quick, in-office procedure',
      'Minimal downtime and quick recovery',
      'Does not affect sexual function or pleasure',
      'No long-term side effects',
      'Cost-effective compared to other contraception methods',
    ],
    symptoms: [],
    treatments: [
      'Pre-procedure consultation and evaluation',
      'In-office vasectomy procedure',
      'Post-procedure care instructions',
      'Follow-up semen analysis to confirm success',
    ],
    faqs: [
      { q: 'Is a vasectomy reversible?', a: 'While vasectomy reversal is possible, it is more complex and success rates vary. Vasectomy should be considered a permanent decision.' },
      { q: 'How long is the recovery?', a: 'Most men return to normal activities within a few days. You should avoid strenuous activity for about a week.' },
      { q: 'Will a vasectomy affect my sex drive?', a: 'No, a vasectomy does not affect testosterone levels, sex drive, or the ability to have erections or orgasms.' },
    ],
    cta: 'Schedule your consultation.',
    seoTitle: 'Vasectomy Melbourne FL',
    seoDescription: 'Safe, effective vasectomy performed in-office in Melbourne, FL. Dr. Havkin provides thorough consultation, the procedure, and follow-up care. Call (321) 500-4545.',
    seoKeywords: 'vasectomy Melbourne FL, vasectomy doctor, vasectomy consultation, permanent contraception, in-office vasectomy',
    seoCanonical: '/services/vasectomy',
  };

  return <ServiceTemplate {...data} />;
};

export default Vasectomy;
